export default {"mainContainer":"dJVVg","passageContainer":"UMZ8Q","subQuestionContainer":"arELv"};